'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PersonalView: {
        displayName: 'PersonalView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Personal/default/PersonalView.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var PersonalView = _wrapComponent('PersonalView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(PersonalView, _Component);

    function PersonalView(props) {
        (0, _classCallCheck3.default)(this, PersonalView);
        return (0, _possibleConstructorReturn3.default)(this, (PersonalView.__proto__ || (0, _getPrototypeOf2.default)(PersonalView)).call(this, props));
    }

    (0, _createClass3.default)(PersonalView, [{
        key: 'render',
        value: function render() {
            var show_menu = this.props.show_menu;
            var route = this.props.children.props.route;

            var active = '';

            // TODO LANG проверить, как будет работать при языке, отличном от русского
            switch (route.path) {
                case 'profile':
                    active = 'Профиль';
                    break;
                case 'order-list':
                    active = 'Заказы';
                    break;
                case 'order/:order_id':
                    active = 'Заказы';
                    break;
                case 'addresses':
                    active = 'Адреса';
                    break;
                case 'operations':
                    active = 'Выписка по счёту';
                    break;
                case 'wishlist':
                    active = 'Избранное';
                    break;
                case 'basket':
                    active = 'basket';
                    break;
            }

            return _react3.default.createElement(
                'div',
                { className: 'row' },
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-4 col-md-3 sidemenu-holder', id: 'UserProfileMenu' },
                    show_menu ? _react3.default.createElement(_components2.UserProfileMenu, { active: active }) : null
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-8 col-md-9' },
                    _react3.default.createElement(
                        _components2.Preloader,
                        { preload: this.props.show_preloader },
                        this.props.children
                    )
                )
            );
        }
    }]);
    return PersonalView;
}(_react2.Component), _class.propTypes = {
    show_menu: _react2.PropTypes.bool,
    show_preloader: _react2.PropTypes.any.isRequired
}, _temp));

exports.default = PersonalView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Personal/default/PersonalView.js
// module id = 1837
// module chunks = 0